// extracted by mini-css-extract-plugin
export default {"root":"ChatRoomSearchResults_root__Z2UrG"};